import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { logStartTimeEndTimeChangedCount } from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';
import {
    initializeTimePickerMetricsInfo,
    logEndTimeChangedCount,
    logEndTimeManuallyChangedCount,
    logStartTimeChangedCount,
    logStartTimeManuallyChangedCount,
} from '../mutators/eventMetricsMutators';

orchestrator(logStartTimeEndTimeChangedCount, actionMessage => {
    const metricsInfo = getComposeStore().metricsInfo;

    if (!metricsInfo) {
        return;
    }

    if (
        metricsInfo.startTimeChangedCount == undefined ||
        metricsInfo.endTimeChangedCount == undefined ||
        metricsInfo.startTimeManuallyChangedCount == undefined ||
        metricsInfo.endTimeManuallyChangedCount == undefined
    ) {
        initializeTimePickerMetricsInfo();
    }

    if (actionMessage.isStartTime) {
        if (actionMessage.isManuallyChanged) {
            logStartTimeManuallyChangedCount();
        }

        logStartTimeChangedCount();
    } else {
        if (actionMessage.isManuallyChanged) {
            logEndTimeManuallyChangedCount();
        }

        logEndTimeChangedCount();
    }
});
